<template>
  <div class="lista-component">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-for="(value, name, index) in itemsListComputed" :key="index">
          <span class="font-weight-black">{{value.text}}:</span>
          <span :class="color || ''" >{{value.value}}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
export default {
  name: "ListaComponent",
  props: ["headers", "items", "color"],
  computed: { 
    itemsListComputed() {
      return this.headers.map(header => {
        return { text: header.text, value: this.items[header.value] };
      });
    }
  },
};
</script>